export function getView(selected_appointment_types) {
  return selected_appointment_types.length > 0 ? 'Selected' : 'Empty'
}
